import ApiClient from '@/api/settings/axios';

const apiClient = new ApiClient();

const requestList = () => {
  const getUrl = '/user/corporation/list/s';
  const result = apiClient.get(
    getUrl,
  ).then(
    (res) => res,
  ).catch(
    (err) => err,
  );
  return result;
};

export default requestList;
